export const PROCESSING_CODES = {
  standard: 'STANDARD',
  month1: 'MONTH_1',
  month3: 'MONTH_3',
  month6: 'MONTH_6',
  month12: 'MONTH_12',
};

export const PROCESSING_LABELS = {
  [PROCESSING_CODES.standard]: 'Standard',
  [PROCESSING_CODES.month1]: 'Month to Month',
  [PROCESSING_CODES.month3]: '3 Month',
  [PROCESSING_CODES.month6]: '6 Month',
  [PROCESSING_CODES.month12]: '12 Month',
};
